module.exports = __webpack_public_path__ + "assets/images/deep-sunset.webp";